import React, { useEffect, useState } from 'react';
import { Wheel } from 'react-custom-roulette';
import { useBackendApi } from '../../helpers/backendHelper';
import { useLoginHelper } from '../../helpers/login/loginHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { trackClairtyEvent } from '../../utils';
import { FlexboxColumn } from '../action/Flexbox';
import TwitterButton from '../action/TwitterButton';
import ButtonApi from '../ButtonApi';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import './SpinWheel.scss';
const data = [{ option: '💪' }, { option: '😨' }, { option: '⭐' }, { option: '🤢' }, { option: '😍' }, { option: '💀' }];
// const data = [{ option: 'Win ' }, { option: 'Try Again' },{ option: 'Try Again' },{ option: 'Try Again' },{ option: 'Try Again' },{ option: 'Try Again' },{ option: 'Try Again' },{ option: 'Try Again' },{ option: 'Try Again' },{ option: 'Try Again' },];

const SpinWheel = ({ onResult }) => {
  const backendHelper = useBackendApi();
  const [{ user, setUser }] = useGlobalState();
  const { twitterLogin } = useLoginHelper();
  const [mustSpin, setMustSpin] = useState(false);
  const [isSpinning, setisSpinning] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [spun, setSpun] = useState(true);
  const [win, setIsWin] = useState();

  const handleSpinClick = async () => {
    try {
      if (spun) return;

      setisSpinning(true);
      // Simulated API call
      const result = await createInviteCodes();
      trackClairtyEvent('spinwheel', { address: user?.address });

      const didWin = result?.win; // expects { win: true } or { win: false }
      setIsWin(didWin);
      const winIndexes = [0, 2, 4];
      const loseIndexes = [1, 3, 5];

      const chosenIndex = didWin ? winIndexes[Math.floor(Math.random() * winIndexes.length)] : loseIndexes[Math.floor(Math.random() * loseIndexes.length)];

      setPrizeNumber(chosenIndex);
      setMustSpin(true);
      setSpun(true);
    } catch (error) {}
  };

  async function createInviteCodes() {
    try {
      await backendHelper.reviews.createInviteCodes();

      trackClairtyEvent('spin_wheel', {
        result: 'win',
      });

      return { win: true };
    } catch (error) {
      trackClairtyEvent('spin_wheel', {
        result: 'false',
      });

      return { win: false };
    }
  }

  async function checkAlreadySpin() {
    try {
      const data = await backendHelper.reviews.spinsUsed();
      setSpun(!(data.data.length === 0));
    } catch (error) {
      setSpun(true);
    }
  }
  useEffect(() => {
    checkAlreadySpin();
  }, []);

  useEffect(() => {
    const handleMessage = event => {
      if (event.data?.type === 'TWITTER_AUTH_SUCCESS') {
        const { user } = event.data;
        if (user) {
          trackClairtyEvent('twitter_connect', {
            connect_place: 'spin',
          });

          setUser(user);
        }
        console.log('Logged in with Twitter:', user);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <FlexboxColumn className='feed_wrapper feed_overflow' gap='1.5rem' justifyContent={'flex-start'}>
      <FlexboxColumn gap='0.5rem' style={{ textAlign: 'center' }}>
        <ThemedText.H2 weight='medium'>
          The Wheel of <b>Karma</b>.
        </ThemedText.H2>
        <ThemedText.H5 color='color-xlight'>
          Spin the wheel to unlock 5 invite codes. <br /> ⁠The more good karma in past life = more chances of winning.
        </ThemedText.H5>
      </FlexboxColumn>
      <div className='spin_wheel_wrapper'>
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={prizeNumber}
          data={data}
          onStopSpinning={() => {
            setMustSpin(false);
            setisSpinning(false);
            if (onResult) onResult(win);
          }}
          outerBorderColor={['#E7EAFF']}
          outerBorderWidth={0}
          innerBorderColor={['#E7EAFF']}
          radiusLineColor={['#E7EAFF']}
          radiusLineWidth={2}
          fontSize={64}
          textColors={['#333']}
          backgroundColors={['#7284FF', '#E7EAFF']}
        />
      </div>

      {user?.twitterId ? (
        <ButtonApi className='spin-button' onClick={handleSpinClick} disabled={spun}>
          {isSpinning ? 'Spinning' : spun ? 'You lost 🙁' : 'Spin the Wheel'}
        </ButtonApi>
      ) : (
        <FlexboxColumn>
          <TwitterButton onClick={twitterLogin}>
            <ThemeLogo icon={'twitterLogo'} />
            <ThemedText.H5>Connect Twitter</ThemedText.H5>
          </TwitterButton>
          {/* {redirected && <a onClick={() => twitterLogin(false)}>Retry </a>} */}
        </FlexboxColumn>
      )}
      {/* {user?.twitterId && <ThemedText.H6 color='color-xlight'>Twitter Connected @{user?.twitterUsername}</ThemedText.H6>} */}
    </FlexboxColumn>
  );
};

export default SpinWheel;
